import { parseJsonColumn } from './parseJsonColumn';
export const EMPTY_ONBOARDING_OVERVIEW_COPY = Object.freeze({
  screen1: { headline: '', body: '' },
  screen2: { headline: '', body: '' },
  screen3: { headline: '', body: '' },
});

type OnboardingOverviewScreenCopy = {
  headline: string;
  body: string;
};

const readString = (value: unknown) => (typeof value === 'string' ? value : '');

const readScreenCopy = (value: unknown): OnboardingOverviewScreenCopy => {
  if (!value || typeof value !== 'object') {
    return { headline: '', body: '' };
  }

  const screen = value as Record<string, unknown>;

  return {
    headline: readString(screen.headline),
    body: readString(screen.body),
  };
};

export const parseOnboardingOverviewCopy = (rawValue: unknown) => {
  const parsed = parseJsonColumn(rawValue);

  return {
    screen1: readScreenCopy(parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>).screen1 : null),
    screen2: readScreenCopy(parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>).screen2 : null),
    screen3: readScreenCopy(parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>).screen3 : null),
  };
};
